import React from 'react';
import client from 'utils/client';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Formik, Form } from 'formik';
import dayjs from 'dayjs';
import { useToast } from 'components/Toast/useToast';
import './edit-merchant.css';
import MerchantForm from '../shared/MerchantForm';

function editMerchant(id, payload) {
  return client.put(`/merchants/${id}/update`, payload);
}
export default function EditMerchant() {
  const { state } = useLocation();
  const { id } = useParams();
  let navigate = useNavigate();
  const { onOpen } = useToast();
  const [merchant, setMerchant] = React.useState(state?.merchant || null);

  React.useEffect(() => {
    if (merchant) return;
    client.get(`/merchants/${id}`)
      .then((res) => setMerchant(res.data.data))
      .catch((err) => {
        onOpen({ type: 'error', message: err?.message || 'Failed to load merchant' });
        navigate('/merchants');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (!merchant) {
    return <div className='new-merchant'><h1 className='add-merchant-title'>Edit Merchant</h1><p>Loading…</p></div>;
  }

  const initialValues = {
    firstName: merchant.first_name ?? '',
    lastName: merchant.last_name ?? '',
    phoneNumber: merchant.phone_number ?? '',
    email: merchant.email ?? '',
    stateOfOrigin: merchant.state_of_origin ?? '',
    accountNumber: merchant.account_number ?? '',
    bankCode: merchant.bank_code ?? '',
    bankName: merchant.bank_name ?? '',
    address: merchant.address ?? '',
    city: merchant.city ?? '',
    lga: merchant.lga ?? '',
    state: merchant.state ?? '',
    nearestBusStop: merchant.nearest_bus_stop ?? '',
    businessStartDate: dayjs(merchant.business_start_date).format('YYYY-MM-DD') ?? null,
    businessSegment: merchant.business_segment ?? '',
    transactionFee: merchant.transaction_fee ?? '',
    transactionFeeCap: merchant.transaction_fee_Cap ?? '',
  };

  function handleSubmit(values) {
    return editMerchant(merchant.id, values)
      .then(() => {
        onOpen({ message: 'Updated Successfully' });
        navigate('/merchants');
      })
      .catch((err) => {
        onOpen({ type: 'error', message: err?.message || 'An Error Occured' });
      });
  }

  function toggleMerchant() {
    return editMerchant(merchant.id, { active: !merchant.active })
      .then(() => {
        onOpen({ message: 'Updated Successfully' });
        navigate('/merchants');
      })
      .catch((err) => {
        onOpen({ type: 'error', message: err?.message || 'An Error Occured' });
      });
  }

  return (
    <div className='new-merchant'>
      <h1 className='add-merchant-title'>Edit Merchant</h1>
      <Formik initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
        {({ isSubmitting }) => (
          <Form className='add-merchant-form'>
            <MerchantForm />
            <div className='edit-merchant-button-container'>
              <button type='submit' className='add-merchant-button' disabled={isSubmitting}>
                Edit
              </button>
              <button
                type='button'
                className={`disable-merchant-button ${merchant.active ? 'inactive' : ''}`}
                disabled={isSubmitting}
                onClick={toggleMerchant}>
                {merchant.active ? 'Disable' : 'Enable'}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
